import classes from "./AnnouncementsLazyList.module.css";
import React from "react";
import PartnerProfileSummary from "../Partner/PartnerProfileSummary";
import PartnerProfile from "../../user/partner/PartnerProfile";
import Spinner from "../common/Spinner/Spinner";

type Props = {
  items?: PartnerProfile[];
  isLoading: boolean;
  loadedAll: boolean;
  announcementItemView?: string;
  title?: string;
  onClickAnnouncement?: (announcementId: string) => void;
  onEditAnnouncement?: (announcementId: string) => void;
  onOpenModal?: (announcementId: string, type: "remove" | "") => void;
  verifiedLabelVisible?: boolean;
};

const ANNOUNCEMENT_FETCH_HEIGHT_THRESHOLD = 600;

const AnnouncementsLazyList = ({
  items,
  loadedAll,
  isLoading,
  announcementItemView,
  title,
  onClickAnnouncement,
  onEditAnnouncement,
  onOpenModal,
  verifiedLabelVisible,
}: Props) => {
  return (
    <div className={classes.container}>
      {title && <h3 className={classes.title}>{title}</h3>}
      <ul className={classes.announcementsList}>
        {isLoading ? (
          <div className={classes.spinnerContainer}>
            <Spinner />
          </div>
        ) : null}
        {!isLoading && items?.length
          ? items.map((item) => (
              <PartnerProfileSummary
                data={item}
                announcementItemView={announcementItemView}
                onClick={onClickAnnouncement}
              />
            ))
          : null}
      </ul>
      {/*<LazyList*/}
      {/*  renderItem={(item: AnnouncementDetails) => (*/}
      {/*    <PartnerProfileSummary*/}
      {/*      data={partner}*/}
      {/*      announcementItemView={announcementItemView}*/}
      {/*      onClickAnnouncement={onClickAnnouncement}*/}
      {/*      onEditAnnouncement={onEditAnnouncement}*/}
      {/*      onDuplicateAnnouncement={onDuplicateAnnouncement}*/}
      {/*      onActivateAnnouncement={onActivateAnnouncement}*/}
      {/*      onFixAnnouncement={onFixAnnouncement}*/}
      {/*      onExtendAnnouncement={onExtendAnnouncement}*/}
      {/*      onResumeAnnouncement={onResumeAnnouncement}*/}
      {/*      onOpenModal={onOpenModal}*/}
      {/*      {...(verifiedLabelVisible && { verified: item.verified })}*/}
      {/*    />*/}
      {/*  )}*/}
      {/*  items={items}*/}
      {/*  listClassName={classes.announcementsList}*/}
      {/*  fetchMore={fetchMore}*/}
      {/*  isLoading={isLoading}*/}
      {/*  loadedAll={loadedAll}*/}
      {/*  fetchHeightThreshold={ANNOUNCEMENT_FETCH_HEIGHT_THRESHOLD}*/}
      {/*/>*/}
    </div>
  );
};

export default AnnouncementsLazyList;
